import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/analytics';
import config from './firebaseConfig';

const app = firebase.initializeApp(config);
const analytics = firebase.analytics();
export default app;
const db = app.firestore();
const auth = app.auth();

// eslint-disable-next-line
if (location.hostname === 'localhost' && false) {
  db.settings({
    host: 'localhost:9000',
    ssl: false,
  });
}
export {
  app,
  firebase,
  db,
  analytics,
  auth,
};
